import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatSidenavContent } from '@angular/material';
import { MediaObserver } from '@angular/flex-layout';
import { combineLatest, Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil, tap } from 'rxjs/operators';
import { format, isValid } from 'date-fns';
import { SessionStorage } from 'ngx-webstorage';
import { ApplicationService, CurrentRequestInfo } from 'services/application/application.service';
import { AuthService } from 'services/authentication/auth.service';
import { DialogService } from 'services/dialogs/dialogs.service';
import { ErrorService } from 'services/error/error.service';
import { ScrollService } from 'services/scroll/scroll.service';
import { UserService } from 'services/user/user.service';
import { BUILD_NOTES, BUILD_TIME, VERSION_NUMBER } from 'services/version/version.service';
import { UnsavedChangesService } from 'routes/routes.guard';
import { RequestIssuePipe } from 'pipes/requestissue.pipe';
var AppComponent = /** @class */ (function () {
    function AppComponent(appService, authService, dialogService, errorService, media, requestIssuePipe, router, scrollSvc, unsavedChangesSvc, userService) {
        var _this = this;
        this.appService = appService;
        this.authService = authService;
        this.dialogService = dialogService;
        this.errorService = errorService;
        this.media = media;
        this.requestIssuePipe = requestIssuePipe;
        this.router = router;
        this.scrollSvc = scrollSvc;
        this.unsavedChangesSvc = unsavedChangesSvc;
        this.userService = userService;
        this._subRelease = new Subject();
        this.title = 'IRIS';
        var self = this;
        this.AboutFn = this.About.bind(this);
        this.BuildNotes = BUILD_NOTES;
        this.CurrentRequest = null;
        this.CurrentRole = '';
        this.LogoutFn = this.Logout.bind(this);
        this.MenuOpen = false;
        this.SmallDisplay = false;
        this.SuppressOutOfOfficeAlert = false; // Default to showing (if applicable)
        this.UpdateAvailable = false;
        this.VersionLoaded = VERSION_NUMBER;
        this.ViewReady = false;
        var btime = new Date(BUILD_TIME);
        if (isValid(btime)) {
            self.BuildTime = format(btime, 'MMM. DD, YYYY h:mm a');
        }
        // Subscribe to checks for a version upgrade
        self.authService.HasVersionUpdate.pipe(takeUntil(self._subRelease)).subscribe(function (value) {
            // Set the upgrade alert banner (or not)
            self.UpdateAvailable = value;
        });
        // Subscribe to media changes
        self.media.media$.pipe(takeUntil(self._subRelease)).subscribe(function (change) {
            self.SmallSize = self.media.isActive('xs') || self.media.isActive('sm');
            self.SmallDisplay = self.SmallSize;
            self.SizeCode =
                change.mqAlias === 'xl'
                    ? 'xl'
                    : change.mqAlias === 'lg'
                        ? 'lg'
                        : change.mqAlias === 'md'
                            ? 'md'
                            : change.mqAlias === 'sm'
                                ? 'sm'
                                : 'xs';
            if (self.SmallSize) {
                self.MenuOpen = false;
            }
            else {
                self.MenuOpen = true;
            }
        });
        self.SmallSize = self.media.isActive('xs') || self.media.isActive('sm');
        self.SmallDisplay = self.SmallSize;
        self.SizeCode = self.media.isActive('xl')
            ? 'xl'
            : self.media.isActive('lg')
                ? 'lg'
                : self.media.isActive('md')
                    ? 'md'
                    : self.media.isActive('sm')
                        ? 'sm'
                        : 'xs';
        self.LastSizeCode = self.SizeCode;
        if (self.SmallSize) {
            self.MenuOpen = false;
        }
        else {
            self.MenuOpen = true;
        }
        // Subscribe to scroll events, so we can scroll up the sidenav content (if needed)
        self.scrollSvc.ScrollEvent.pipe(takeUntil(self._subRelease)).subscribe(function (scrollAmt) {
            if (self.sidenavContent) {
                self.sidenavContent.scrollTo({
                    top: scrollAmt || 0,
                });
            }
        });
        // Subscribe to the user information, and keep it updated, along with the nav menu. Also keep a subscription to the
        // current request ID, so if it is set we have a menu button pop for that.
        combineLatest(self.userService.UserSubject, self.appService.CurrentRequestSubject)
            .pipe(takeUntil(self._subRelease), map(function (_p) {
            return {
                UserInfo: _p[0],
                CurReq: _p[1],
            };
        }), distinctUntilChanged())
            .subscribe(function (_datapack) {
            self.User = _datapack.UserInfo;
            self.CurrentRequest = _datapack.CurReq;
            if (self.User) {
                // Reset the out of office suppression, if the role has changed from the current role. (We don't
                // need to do this if this is triggered by an authtoken change, or a request change.)
                if (self.CurrentRole !== self.User.CurrentRole) {
                    self.SuppressOutOfOfficeAlert = false;
                    self.CurrentRole = self.User.CurrentRole;
                }
                // [Re]set the navmenu entries
                var navitems = [];
                navitems.push({
                    MenuText: 'Home',
                    MenuIcon: 'home',
                    AllowedRoles: ['all'],
                    LinkedStates: ['/home'],
                    IsHome: true,
                    ActionRoute: ['/home'],
                });
                navitems.push({
                    MenuText: 'Create New Request',
                    MenuIcon: 'note_add',
                    AllowedRoles: ['BoardMember', 'BoardAssistant', 'Facilitator', 'Developer'],
                    LinkedStates: ['/create'],
                    ActionRoute: ['/create'],
                });
                if (self.CurrentRequest && self.CurrentRequest.RequestID != null) {
                    navitems.push({
                        MenuText: "View Request " + self.requestIssuePipe.transform(self.CurrentRequest.IssueNumber, self.CurrentRequest.FiscalYear),
                        MenuIcon: 'find_in_page',
                        AllowedRoles: ['all'],
                        LinkedStates: self.User.CurrentRole === 'BoardMember' || self.User.CurrentRole === 'BoardAssistant'
                            ? ['/requestview']
                            : ['/handlerequest'],
                        ActionRoute: self.User.CurrentRole === 'BoardMember' || self.User.CurrentRole === 'BoardAssistant'
                            ? [
                                "/requestview" + (self.CurrentRequest && self.CurrentRequest.RequestID != null
                                    ? '/' + self.CurrentRequest.RequestID
                                    : ''),
                            ]
                            : [
                                "/handlerequest" + (self.CurrentRequest && self.CurrentRequest.RequestID != null
                                    ? '/' + self.CurrentRequest.RequestID
                                    : ''),
                            ],
                    });
                }
                navitems.push({
                    MenuText: 'Unassigned Requests',
                    MenuIcon: 'assignment_late',
                    AllowedRoles: ['Facilitator', 'Developer'],
                    LinkedStates: ['/cabinetunassigned'],
                    ActionRoute: ['/cabinetunassigned'],
                });
                navitems.push({
                    MenuText: 'Review My Referrals',
                    MenuIcon: 'assignment_ind',
                    AllowedRoles: ['Cabinet', 'Responder'],
                    LinkedStates: ['/referrals'],
                    ActionRoute: ['/referrals'],
                });
                navitems.push({
                    MenuText: 'Referrals Needing Action',
                    MenuIcon: 'assignment',
                    AllowedRoles: ['Facilitator', 'Developer'],
                    LinkedStates: ['/actionneeded'],
                    ActionRoute: ['/actionneeded'],
                });
                navitems.push({
                    MenuText: 'View My Requests',
                    MenuIcon: 'assignment',
                    AllowedRoles: ['BoardMember'],
                    LinkedStates: ['/myrequests'],
                    ActionRoute: ['/myrequests'],
                });
                navitems.push({
                    MenuText: "View Others' Requests",
                    MenuIcon: 'assignment',
                    AllowedRoles: ['BoardMember'],
                    LinkedStates: ['/otherrequests'],
                    ActionRoute: ['/otherrequests'],
                });
                navitems.push({
                    MenuText: "View Board Requests",
                    MenuIcon: 'assignment',
                    AllowedRoles: ['BoardAssistant'],
                    LinkedStates: ['/boardrequests'],
                    ActionRoute: ['/boardrequests'],
                });
                // TODO - Release this back to board once that's worked out
                navitems.push({
                    MenuText: 'Search',
                    MenuIcon: 'search',
                    AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent', 'Cabinet', 'Responder', 'Facilitator'],
                    LinkedStates: ['/search'],
                    ActionRoute: ['/search'],
                });
                navitems.push({
                    MenuText: 'Data Dashboard',
                    MenuIcon: 'insert_chart',
                    AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent'],
                    LinkedStates: ['/dashboard'],
                    ActionRoute: ['/dashboard'],
                });
                navitems.push({
                    MenuText: 'Out Of Office Settings',
                    MenuIcon: 'contact_mail',
                    AllowedRoles: ['Cabinet', 'Developer', 'SystemAdmin', 'Superintendent', 'DeputySuperintendent'],
                    LinkedStates: ['/outofoffice'],
                    ActionRoute: ['/outofoffice'],
                });
                // System Tools
                var sysMenus = [
                    {
                        MenuText: 'Board Assistants',
                        MenuIcon: 'people',
                        AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent'],
                        LinkedStates: ['/boardassistants'],
                        ActionRoute: ['/boardassistants'],
                    },
                    {
                        MenuText: 'Categories',
                        MenuIcon: 'list',
                        AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent'],
                        LinkedStates: ['/categories'],
                        ActionRoute: ['/categories'],
                    },
                    {
                        MenuText: 'Email Settings',
                        MenuIcon: 'email',
                        AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent'],
                        LinkedStates: ['/emailpreferences'],
                        ActionRoute: ['/emailpreferences'],
                    },
                    {
                        MenuText: 'Facilitators',
                        MenuIcon: 'people',
                        AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent'],
                        LinkedStates: ['/facilitators'],
                        ActionRoute: ['/facilitators'],
                    },
                    {
                        MenuText: 'Cabinet Members',
                        MenuIcon: 'people',
                        AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent'],
                        LinkedStates: ['/cabinetmembers'],
                        ActionRoute: ['/cabinetmembers'],
                    },
                ];
                navitems.push({
                    MenuText: 'System Settings',
                    MenuIcon: 'settings',
                    AllowedRoles: ['Developer', 'Superintendent', 'DeputySuperintendent'],
                    Submenus: sysMenus,
                });
                // Rest of menu entries
                // navitems.push({
                //     MenuText: 'Reports & Exports',
                //     MenuIcon: 'file_download',
                //     AllowedRoles: [
                //         'SystemAdmin',
                //         'Developer',
                //     ],
                //     LinkedStates: ['~/reports'],
                //     ActionRoute: ['~/reports'],
                // });
                navitems.push({
                    MenuText: 'Logout',
                    MenuIcon: 'exit_to_app',
                    AllowedRoles: ['all'],
                    IsLogout: true,
                });
                navitems.push({
                    MenuText: 'About IRIS',
                    MenuIcon: 'help',
                    AllowedRoles: ['all'],
                    IsAbout: true,
                });
                // Set the property
                self.MenuItems = navitems;
            }
        });
        // Subscribe to system online status updates. If the system goes offline, this may cause us to reroute to the offline route.
        self.authService.SystemOnlineSubject.pipe(takeUntil(self._subRelease), distinctUntilChanged(function (p, c) { return p.Status === c.Status; })).subscribe(function (status) {
            if (status && status.Status) {
                // The system is showing as online. Load/refresh the system variables needed for working the app.
                var _schoolsObs = self.appService.GetAllSchools();
                var _schoolYearsObs = self.appService.GetAllSchoolYears();
                var _categoriesObs = self.appService.GetAllCategories();
                var _boardObs = self.appService.GetAllBoardMembers();
                var _cabinetObs = self.appService.GetAllCabinetMembers();
                var _emailPrefOptsObs = self.appService.GetEmailPreferenceOptions();
                var _workdaysObs = self.appService.GetWorkdayCalendar(true);
                combineLatest(_schoolsObs, _schoolYearsObs, _categoriesObs, _boardObs, _cabinetObs, _emailPrefOptsObs, _workdaysObs)
                    .pipe(takeUntil(self._subRelease), map(function (packet) {
                    return {
                        Schools: packet[0],
                        SchoolYears: packet[1],
                        Categories: packet[2],
                        BoardMembers: packet[3],
                        CabinetMembers: packet[4],
                        EmailPreferenceOptions: packet[5],
                        WorkDays: packet[6],
                    };
                }))
                    .subscribe(function (info) {
                    self.ViewReady = true;
                    if (!self.router.url || self.router.url === '/' || self.router.url === '/offline') {
                        // On the unrouted path. Go to the login route.
                        self.router.navigate(['/login']);
                        return;
                    }
                }, function (error) { return self.errorService.HandleServiceError(error, self.User); });
            }
            else {
                // The system is showing as offline. If the current route is the offline route or the landing route, route to the offline route.
                self.ViewReady = true;
                // If there's no auth token in use, route to the offline page.
                if (!self.userService || !self.userService.User || !self.userService.User.AuthToken) {
                    self.router.navigate(['/offline']);
                }
            }
        });
        // Conduct an initial test of the connection, to set the proper status.
        this.authService.TestConnection().subscribe(function (result) {
            _this.authService.SetSystemOnlineStatus(result);
        }, function (err) {
            // A failure would indicate the system is offline.
            _this.authService.SetSystemOnlineStatus({
                Status: false,
                SystemMessage: '',
                IRISVersion: VERSION_NUMBER,
            });
        });
    }
    AppComponent.prototype.ngOnDestroy = function () {
        this._subRelease.next();
        this._subRelease.complete();
        this.authService.CancelAuthTokenRefreshing();
    };
    AppComponent.prototype.ngOnInit = function () { };
    // #region About Method
    AppComponent.prototype.About = function () {
        var self = this;
        if (self.SmallSize) {
            self.MenuOpen = false;
        }
        var msg = "The IRIS System is a product of the Polk County Public Schools system. The system provides a single convenient location for School Board members " +
            "and outside constituents to request information and receive timely responses from district staff.<br /><br />" +
            ("<strong>IRIS Version: </strong>" + self.VersionLoaded + "<br />\n    <strong>Build Date/Time: </strong>" + self.BuildTime);
        if (self.BuildNotes) {
            msg += "<br /><strong>Build Notes: </strong><br />" + self.BuildNotes;
        }
        return self.dialogService.OpenMessageBoxDialog({
            TitleText: 'About IRIS System',
            MessageText: msg,
            height: self.BuildNotes ? '450px' : '400px',
        });
    };
    // #endregion
    // #region Change Theme Method
    AppComponent.prototype.ChangeTheme = function () {
        this.otherTheme = !this.otherTheme;
        this.appService.ToggleTheme();
    };
    // #endregion
    // #region Dismiss Out Of Office
    AppComponent.prototype.DismissOutOfOffice = function () {
        this.SuppressOutOfOfficeAlert = true;
    };
    // #endregion
    // #region Get Update Method
    AppComponent.prototype.GetUpdate = function () {
        // Get a confirmation
        this.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Site Update Available',
            MessageText: "An update is available to the IRIS System. Updates typically fix issues reported " +
                "by users or offer new features. If you are encountering problems with the site, it is recommended that " +
                "you load the update for the website at this time.<br /><br /><strong>Note: </strong>Loading the update " +
                "will refresh your page and you will lose any unsubmitted changes.",
            OKText: 'Load Update',
            CancelText: 'CANCEL',
        })
            .subscribe(function (res) {
            if (res === true) {
                // User is opting to load the update. Refresh the page without caching.
                location.reload(true);
            }
        });
    };
    // #endregion
    // #region Go Home Method
    AppComponent.prototype.GoHome = function () {
        if (this.userService.User == null || this.userService.User.AuthToken == null) {
            this.router.navigate(['/login']);
        }
        else {
            this.router.navigate(['/home']);
        }
    };
    // #endregion
    // #region Go To Out Of Office
    AppComponent.prototype.GoToOutOfOffice = function () {
        this.router.navigate(['outofoffice']);
    };
    // #endregion
    // #region Logout Method
    AppComponent.prototype.Logout = function () {
        var self = this;
        // Consult the unsaved changes guard (if any) to see if a tracker is in place.
        var opts = null;
        if (self.unsavedChangesSvc.IsTracking()) {
            return self.unsavedChangesSvc.CheckTracker().pipe(takeUntil(self._subRelease), tap(function (result) {
                if (result === true) {
                    // The tracker says it's okay to logout, Go ahead and logout without further confirmation.
                    self.authService.Logout(null, null);
                }
            }));
        }
        else {
            // No tracker in place. Use a usual prompt process.
            opts = {
                TitleText: 'Confirmation Requested',
                MessageText: 'You are about to log out of the IRIS System. Are you sure you wish to exit at this time?',
                OKText: 'Yes - Log Out',
                CancelText: 'No - Stay Logged In',
            };
            return self.dialogService.OpenConfirmationDialog(opts).pipe(tap(function (confresult) {
                if (confresult === true) {
                    // User is opting to log out. Proceed.
                    self.authService.Logout(null, null);
                }
            }));
        }
    };
    // #endregion
    // #region Navigate Method
    AppComponent.prototype.Navigate = function (event) {
        if (this.SmallSize) {
            this.MenuOpen = false;
        }
    };
    // #endregion
    // #region Toolbar About Method
    AppComponent.prototype.ToolbarAbout = function () {
        this.About()
            .pipe(takeUntil(this._subRelease))
            .subscribe();
    };
    // #endregion
    // #region Toolbar Logout Method
    AppComponent.prototype.ToolbarLogout = function () {
        this.Logout()
            .pipe(takeUntil(this._subRelease))
            .subscribe();
    };
    // #endregion
    // #region Toggle Nav Menu Method
    AppComponent.prototype.ToggleNavMenu = function () {
        this.MenuOpen = !this.MenuOpen;
    };
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Boolean)
    ], AppComponent.prototype, "SuppressOutOfOfficeAlert", void 0);
    return AppComponent;
}());
export { AppComponent };
